import { defineStore } from 'pinia'
import type { UserState } from './helper'
import { defaultSetting, getLocalState, setLocalState } from './helper'
import { getUserRoleInfo } from '@/api/users'

export const useUserStore = defineStore('user-store', {
  state: (): UserState => getLocalState(),
  actions: {
    updateUserInfo(userInfo: Partial<Auth.userInfo>) {
      this.userInfo = { ...this.userInfo, ...userInfo }
      this.recordState()
    },

    resetUserInfo() {
      this.userInfo = { ...defaultSetting().userInfo }
      this.recordState()
    },

    updateWorkSpace(workspace: { name: string | null; id: number | null; canEdit: boolean; grading_scale: number | null; type: string | null; workSpaceLogo: string | null }) {
      this.workSpace = workspace.name
      this.workSpaceId = workspace.id
      this.canEdit = workspace.canEdit
      if (workspace?.grading_scale)
        this.grading_scale = workspace.grading_scale

      this.type = workspace.type
      this.workSpaceLogo = workspace.workSpaceLogo

      this.recordState()
    },

    setShowRequestWorkspace(show: boolean) {
      this.showRequestWorkspace = show
      this.recordState()
    },

    setIsFirstLogin(isFirstLogin: boolean) {
      this.isFirstLogin = isFirstLogin
      this.recordState()
    },

    updateWorkSpaceGradingScale(grading_scale: number) {
      this.grading_scale = grading_scale
      this.recordState()
    },

    removeWorkSpace() {
      this.userInfo = {}
      this.workSpace = ''
      this.workSpaceId = 0
      this.workSpaceLogo = ''
      this.canEdit = false
      this.role = null
      this.grading_scale = 10
      this.type = null
      this.showRequestWorkspace = false
      this.isFirstLogin = false
      this.recordState()
    },

    recordState() {
      setLocalState(this.$state)
    },

    async fetchUserRoleInfo() {
      if (this.workSpaceId) {
        const res = await getUserRoleInfo(this.workSpaceId)
        if (res.data) {
          this.role = res.data
          // this.userInfo = { ...this.userInfo, ...res.data }
          this.recordState()
        }
      }
    },
  },
})
